import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Contact = () => {
  const { t, isRTL } = useLanguage();
  const c = t.contact;

  const contactItems = [
    { icon: 'fa fa-phone', title: c.phone, value: '06 04 18 06 71' },
    { icon: 'fab fa-linkedin', title: c.linkedin, value: 'Nathan-BENAIS', link: 'https://www.linkedin.com/in/nathan-benais-5b925219a/' },
    { icon: 'fa fa-envelope', title: c.emailLabel, value: 'nathan.benais@gmail.com' },
    { icon: 'fab fa-github', title: c.github, value: 'NathanBENAIS', link: 'https://github.com/NathanBENAIS' },
  ];

  const handleBackToTop = (e) => {
    e.preventDefault();
    const target = document.querySelector('#home');
    if (target) window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
  };

  return (
    <section id="contact" className="py-20 px-5 bg-bg-black-900">
      <div className="container mx-auto max-w-6xl">
        <div className="section-title mb-16">
          <h2 className="text-4xl font-bold relative inline-block pb-3">{c.title}</h2>
        </div>

        <h3 className="text-2xl text-skin-color text-center mb-5">{c.subtitle}</h3>

        {/* Contact info */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {contactItems.map((item, idx) => (
            <div key={idx} className="p-6 text-center">
              <div className="mb-4 flex justify-center">
                <i className={`${item.icon} text-2xl text-skin-color`}></i>
              </div>
              <h4 className="text-lg font-bold mb-2 text-text-black-900">{item.title}</h4>
              <p className="text-text-black-700">
                {item.link ? (
                  <a href={item.link} target="_blank" rel="noopener noreferrer" className="hover:underline">{item.value}</a>
                ) : item.value}
              </p>
            </div>
          ))}
        </div>

        <h3 className="text-2xl text-skin-color text-center mb-3">{c.sendMail}</h3>
        <h4 className="text-lg text-text-black-900 text-center mb-12">{c.reactive}</h4>

        {/* Form */}
        <div className="p-8">
          <form action="https://formsubmit.co/nathan.benais@gmail.com" method="POST" className="w-full">
            <input type="hidden" name="_subject" value="New mail !!" />

            <div className="flex flex-wrap -mx-3 mb-6">
              <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                <input
                  type="text"
                  name="name"
                  placeholder={c.namePlaceholder}
                  className="w-full h-12 px-6 rounded-full bg-bg-black-100 border border-bg-black-50 text-text-black-700 focus:shadow-md transition-shadow duration-300"
                />
              </div>
              <div className="w-full md:w-1/2 px-3">
                <input
                  type="email"
                  name="email"
                  placeholder={c.emailPlaceholder}
                  required
                  className="w-full h-12 px-6 rounded-full bg-bg-black-100 border border-bg-black-50 text-text-black-700 focus:shadow-md transition-shadow duration-300"
                />
              </div>
            </div>

            <div className="mb-6">
              <input
                type="text"
                name="objet"
                placeholder={c.subjectPlaceholder}
                className="w-full h-12 px-6 rounded-full bg-bg-black-100 border border-bg-black-50 text-text-black-700 focus:shadow-md transition-shadow duration-300"
              />
            </div>

            <div className="mb-8">
              <textarea
                name="Message"
                placeholder={c.messagePlaceholder}
                rows="5"
                className="w-full px-6 py-4 rounded-3xl bg-bg-black-100 border border-bg-black-50 text-text-black-700 focus:shadow-md transition-shadow duration-300"
              ></textarea>
            </div>

            <div className={`flex ${isRTL ? 'justify-start' : 'justify-end'}`}>
              <button
                type="submit"
                className="text-base font-medium py-3 px-12 text-white rounded-full inline-block whitespace-nowrap border-none transition-transform duration-300 hover:scale-105"
                style={{ backgroundColor: 'var(--skin-color)' }}
              >
                {c.sendBtn}
              </button>
            </div>
          </form>
        </div>

        {/* Back to top */}
        <div className={`flex ${isRTL ? 'justify-center md:justify-start' : 'justify-center md:justify-end'} mt-16`}>
          <a href="#home" onClick={handleBackToTop} className="group flex items-center text-text-black-900 font-bold">
            <span className={isRTL ? 'ml-2' : 'mr-2'}>{c.backToTop}</span>
            <i className="fa fa-long-arrow-alt-up text-skin-color group-hover:animate-bounce"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
